"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTimezoneLabel = void 0;
/* eslint-disable import/prefer-default-export */
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const { primaryBlueMed200 } = ui_components_1.baseColors;
exports.StyledTimezoneLabel = styled_components_1.default.div `
  margin-left: auto;
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  border: 1px solid ${primaryBlueMed200};
  border-radius: ${({ theme }) => theme.spacing(0.5)};

  span {
    font-weight: 500;
  }
`;
